export enum EndingSpecMode {
  Unspecified,
  DurationOffset,
  ExplicitlyDefined,
}